import { render, staticRenderFns } from "./TriangleTestCreate.vue?vue&type=template&id=ba402a72&scoped=true&"
import script from "./TriangleTestCreate.vue?vue&type=script&lang=js&"
export * from "./TriangleTestCreate.vue?vue&type=script&lang=js&"
import style0 from "./TriangleTestCreate.vue?vue&type=style&index=0&id=ba402a72&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba402a72",
  null
  
)

export default component.exports